"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetRenderer = void 0;
var Renderer_1 = require("./Renderer");
var Person_1 = require("../models/Person");
var Event_1 = require("../models/Event");
var PersonRenderer_1 = require("./PersonRenderer");
var EventRenderer_1 = require("./EventRenderer");
var EraRenderer_1 = require("./EraRenderer");
var Lanes_1 = require("./Lanes");
var FacetRenderer = /** @class */ (function (_super) {
    __extends(FacetRenderer, _super);
    function FacetRenderer(canvas, facet) {
        var _this = _super.call(this, canvas) || this;
        _this.name = facet.name;
        _this.eras = facet.eras;
        _this.lanes = new Lanes_1.Lanes();
        var objects = facet.people
            .concat(facet.events)
            .sort(function (one, two) { return one.orderByStart(two); });
        _this.lanes.addObjects(objects);
        _this.basecolor = facet.basecolor;
        return _this;
    }
    FacetRenderer.prototype.render = function (offset) {
        var _this = this;
        this.eras.forEach(function (era) {
            return new EraRenderer_1.EraRenderer(_this.canvas, era).render(offset, _this.lanes.size() * (_this.LANE_HEIGHT + _this.LANE_PADDING), _this.basecolor);
        });
        offset += this.LANE_PADDING / 2;
        this.lanes.getLanes().forEach(function (lane) {
            lane.forEach(function (object) {
                switch (true) {
                    case object instanceof Person_1.Person:
                        new PersonRenderer_1.PersonRenderer(_this.canvas, object).render(offset, _this.basecolor);
                        break;
                    case object instanceof Event_1.Event:
                        new EventRenderer_1.EventRenderer(_this.canvas, object).render(offset, _this.basecolor);
                        break;
                }
            });
            offset += _this.LANE_HEIGHT + _this.LANE_PADDING;
        });
        return offset - this.LANE_PADDING / 2;
    };
    return FacetRenderer;
}(Renderer_1.Renderer));
exports.FacetRenderer = FacetRenderer;
